export default __webpack_public_path__ + "static/media/treat-yo-self.696102e2.gif";